import request from '@/utils/request';

// 获取省市区数据
export function getAreaSelect(data) {
    return request({
        url: '/logistics/area/getAreaSelect',
        method: 'get',
        data: data
    })
}
export function getLoginPic(data,uuid) {
    return request({
        url: `/wxInterface/getLoginPic/${uuid}`,
        method: 'get',
        responseType:'blob',
        data: data
    })
}
export function getTokenCheck(data,uuid) {
    return request({
        url: `/wxInterface/getToken/${uuid}`,
        method: 'get',
        data: data
    })
}
export function getInfo(data) {
    return request({
        url: '/getInfo',
        method: 'get',
        data: data
    })
}
// 获取配送方式
export function getSendType(data) {
    return request({
        url: '/public/dic/getSendType',
        method: 'get',
        data: data
    })
}
// 获取付款方式
export function getPayType(data) {
    return request({
        url: '/public/dic/getPayType',
        method: 'get',
        data: data
    })
}

// 新增
export function add(data) {
    return request({
        url: '/logisticsExpressage/save',
        method: 'post',
        data: data
    })
}

// 查询
export function search(data,order) {
    return request({
        url: `/logisticsExpressage/wx/detailPc?orderNo=${order}`,
        method: 'get',
        data: data
    })
}

// 轮播

export function banner(data) {
    return request({
        url: '/banner/list',
        method: 'post',
        data: data
    })
}
export function listTable(data) {
    return request({
        url: `/logisticsExpressage/wx/listPc?pageNum=${data.pageNum}&pageSize=${data.pageSize}&createDate=${data.createDate}&phone=${data.phone}`,
        method: 'get',
        data: data,
    })
}
// 查询地址簿
export function addressList(data) {
    return request({
        url: `/logisticsAddressBook/list?dataType=${data.dataType}&searchWord=${data.searchWord}`,
        method: 'post',
        data: data
    })
}
// 上传模板
export function uploadGoods(data){
    return request({
        url: `/logisticsExpressage/goods/importData`,
        method: 'post',
        headers:{
            'Content-type':'multipart/form-data'
        },
        data:data
    })
}
export function batchOrderSave(data) {
    return request({
        url: `/logisticsExpressage/batch/save`,
        method: 'post',
        data: data
    })
}
export function orderPage(data){
    return request({
        url: `/logisticsExpressage/wx/logistics/page?pageNum=${data.pageNum}&pageSize=5`,
        method: 'post',
        data: data
    })
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
      url: '/system/dict/data/type/' + dictType,
      method: 'get'
    })
  }
// 批量下单

// // 下载模板
// /logisticsExpressage/goods/getTemp